import React from "react";

const AUTH_LABELS = {
  required: "Authenticated",
  admin: "Admin Only",
  public: "Public",
  none: "No Auth",
};

const AuthBadge = ({ auth }) => {
  const label = AUTH_LABELS[auth] || AUTH_LABELS.required;
  const className = `api-docs-auth-badge api-docs-auth-badge--${auth || "required"}`;

  return <span className={className}>{label}</span>;
};

export default AuthBadge;
